module.exports = __webpack_public_path__ + "img/HA2512-38.d5abddce.jpg";